import { getMultipleVideoSupportFeatureFlag } from '../config/functions.any';
import { MEDIA_TYPE, VIDEO_TYPE } from '../media/constants';
import { getParticipantById, isScreenShareParticipant } from '../participants/functions';
import { getTrackByMediaTypeAndParticipant, getVirtualScreenshareParticipantTrack } from '../tracks/functions';
/**
 * Indicates whether the test mode is enabled. When it's enabled
 * {@link TestHint} and other components from the testing package will be
 * rendered in various places across the app to help with automatic testing.
 *
 * @param {IReduxState} state - The redux store state.
 * @returns {boolean}
 */
export function isTestModeEnabled(state) {
    const testingConfig = state['features/base/config'].testing;
    return Boolean(testingConfig === null || testingConfig === void 0 ? void 0 : testingConfig.testMode);
}
/**
 * Returns the video type of the remote participant's video.
 *
 * @param {IStore} store - The redux store.
 * @param {string} id - The participant ID for the remote video.
 * @returns {VIDEO_TYPE}
 */
export function getRemoteVideoType({ getState }, id) {
    var _a;
    const state = getState();
    const participant = getParticipantById(state, id);
    if (getMultipleVideoSupportFeatureFlag(state) && isScreenShareParticipant(participant)) {
        return VIDEO_TYPE.DESKTOP;
    }
    return (_a = getTrackByMediaTypeAndParticipant(state['features/base/tracks'], MEDIA_TYPE.VIDEO, id)) === null || _a === void 0 ? void 0 : _a.videoType;
}
/**
 * Returns whether the last media event received for large video indicates that the video is playing, if not muted.
 *
 * @param {IStore} store - The redux store.
 * @returns {boolean}
 */
export function isLargeVideoReceived({ getState }) {
    var _a, _b;
    const state = getState();
    const largeVideoParticipantId = (_a = state['features/large-video'].participantId) !== null && _a !== void 0 ? _a : '';
    const largeVideoParticipant = getParticipantById(state, largeVideoParticipantId !== null && largeVideoParticipantId !== void 0 ? largeVideoParticipantId : '');
    const tracks = state['features/base/tracks'];
    let videoTrack;
    if (getMultipleVideoSupportFeatureFlag(state) && isScreenShareParticipant(largeVideoParticipant)) {
        videoTrack = getVirtualScreenshareParticipantTrack(tracks, largeVideoParticipantId);
    }
    else {
        videoTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.VIDEO, largeVideoParticipantId);
    }
    const lastMediaEvent = (_b = state['features/large-video']) === null || _b === void 0 ? void 0 : _b.lastMediaEvent;
    return Boolean(videoTrack && !videoTrack.muted
        && (lastMediaEvent === 'playing' || lastMediaEvent === 'canplaythrough'));
}
/**
 * Returns whether the last media event received for a remote video indicates that the video is playing, if not muted.
 *
 * @param {IStore} store - The redux store.
 * @param {string} id - The participant ID for the remote video.
 * @returns {boolean}
 */
export function isRemoteVideoReceived({ getState }, id) {
    const state = getState();
    const tracks = state['features/base/tracks'];
    const participant = getParticipantById(state, id);
    let videoTrack;
    if (getMultipleVideoSupportFeatureFlag(state) && isScreenShareParticipant(participant)) {
        videoTrack = getVirtualScreenshareParticipantTrack(tracks, id);
    }
    else {
        videoTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.VIDEO, id);
    }
    const lastMediaEvent = videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.lastMediaEvent;
    return Boolean(videoTrack && !videoTrack.muted
        && (lastMediaEvent === 'playing' || lastMediaEvent === 'canplaythrough'));
}
